import React, { useEffect } from "react";
import "./DataTable.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { DataItem } from "src/types/configuration";

type WallPlankRow = {
  parentName: string;
  label: string;
  unit: string;
  quantity: number;
};

type TableRow =
  | (DataItem & { isSubItem?: false })
  | (WallPlankRow & { isSubItem: true });

const DataTable: React.FC = () => {
  const { state, calculation } = useConfiguration();
  const [data, setData] = React.useState<DataItem[]>([]);
  const [wallRows, setWallRows] = React.useState<WallPlankRow[]>([]);

  useEffect(() => {
    setTimeout(() => {
      setData(
        calculation.getData().filter((row: DataItem) => row.quantity > 0)
      );
      setWallRows(calculation.getWallPlankBreakdownRows());
    }, 600);
  }, [state, calculation, setData]);

  const rows: TableRow[] = React.useMemo(() => {
    const breakdownMap = wallRows.reduce((acc, row) => {
      if (!acc[row.parentName]) acc[row.parentName] = [];
      acc[row.parentName].push(row);
      return acc;
    }, {} as Record<string, WallPlankRow[]>);

    return data.reduce((acc: TableRow[], row: DataItem) => {
      acc.push(row);
      const subitems = breakdownMap[row.name] ?? [];
      subitems.forEach((subitem) =>
        acc.push({ ...subitem, isSubItem: true })
      );
      return acc;
    }, []);
  }, [data, wallRows]);

  return (
    <div className="data-table">
      <table>
        <thead>
          <tr>
            <th>Materiaal</th>
            <th>Eenheid</th>
            <th>Aantal</th>
            <th>Prijs</th>
            <th>Totaal</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row: TableRow, index: number) => {
            if (!row) return null;
            const isSubItem = "isSubItem" in row && row.isSubItem;
            const quantity = isSubItem
              ? row.quantity
              : calculation.roundValue(row.quantity);
            const price =
              !isSubItem && "price" in row
                ? calculation.formatToCurrency(row.price)
                : "";
            const total =
              !isSubItem && "total" in row
                ? calculation.formatToCurrency(row.total)
                : "";

            return (
              <tr key={index} className={isSubItem ? "subitem" : ""}>
                <td>{row.label}</td>
                <td>{row.unit}</td>
                <td>{quantity}</td>
                <td>{price}</td>
                <td>{total}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="total-price">
        <span>Totaal prijs .incl. BTW</span>
        <span>{calculation.getFormatTotalPrice()}</span>
      </div>
    </div>
  );
};

export default DataTable;
